import { useState } from "react";
import { blogPosts, blogCategories } from "@/mocks/blogPosts";
import { Link } from "react-router-dom";

export default function BlogGrid() {
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered =
    activeCategory === "All"
      ? blogPosts.filter((p) => !p.featured)
      : blogPosts.filter((p) => !p.featured && p.category === activeCategory);

  return (
    <section className="bg-[#f8fcfc] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <p className="text-[#418b86] text-xs font-medium tracking-widest uppercase mb-3">
              Recent Articles
            </p>
            <h2
              className="text-3xl md:text-4xl font-light text-[#2d2d2d] leading-snug"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              More to <span className="italic font-semibold">Explore.</span>
            </h2>
          </div>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2 mb-10">
          {blogCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-[#418b86] text-white"
                  : "bg-white text-[#5a5a5a] border border-[#c8e8e6] hover:border-[#418b86] hover:text-[#418b86]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Blog Grid */}
        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((post) => (
              <article
                key={post.id}
                className="group bg-white rounded-2xl overflow-hidden border border-[#e8f4f3] hover:border-[#c8e8e6] transition-all duration-300 hover:-translate-y-1"
              >
                {/* Image */}
                <div className="h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-3 text-[#9a9a9a] text-xs mb-3">
                    <span className="text-[#418b86] font-medium">{post.category}</span>
                    <span className="w-1 h-1 rounded-full bg-[#c8e8e6]"></span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line text-sm"></i>
                      {post.readTime}
                    </span>
                  </div>

                  <h3
                    className="text-lg font-medium text-[#2d2d2d] leading-snug mb-3 group-hover:text-[#418b86] transition-colors"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {post.title}
                  </h3>

                  <p className="text-[#6b6b6b] text-sm leading-relaxed mb-5 line-clamp-3">
                    {post.excerpt}
                  </p>

                  <div className="flex items-center justify-between">
                    <span className="text-[#9a9a9a] text-xs flex items-center gap-1">
                      <i className="ri-calendar-line text-sm"></i>
                      {post.date}
                    </span>
                    <Link
                      to={`/blog/${post.id}`}
                      className="inline-flex items-center gap-1 text-[#418b86] text-sm font-medium hover:text-[#4db8b1] transition-colors cursor-pointer"
                    >
                      Read
                      <i className="ri-arrow-right-line text-sm"></i>
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#e6f6f5] mx-auto mb-4">
              <i className="ri-article-line text-[#4db8b1] text-xl"></i>
            </div>
            <p className="text-[#6b6b6b] text-sm">
              No articles in this category yet. Check back soon.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}